const baseUrl =
  process.env.REACT_APP_POCKETBASE_URL !== undefined
    ? process.env.REACT_APP_POCKETBASE_URL
    : 'http://127.0.0.1:8090';

function parseMeasuredAt(value) {
  if (!value) {
    return null;
  }

  const normalized = value.includes('T') ? value : value.replace(' ', 'T');
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

function optionalNumber(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function mapVitals(record) {
  if (record.hasVitals !== true) {
    return { inp: null, cls: null, ti: null };
  }

  const inp = optionalNumber(record.inp);
  const ti = optionalNumber(record.ti);

  return {
    inp: inp !== null && inp > 0 ? inp : null,
    cls: optionalNumber(record.cls),
    ti: ti !== null && ti > 0 ? ti : null,
  };
}

function mapRecord(record) {
  const measuredAt = parseMeasuredAt(record.datum);
  const vitals = mapVitals(record);

  return {
    id: record.id,
    onPageScore: Number(record.onPageScore) || 0,
    lcp: Number(record.lcp) || 0,
    inp: vitals.inp,
    cls: vitals.cls,
    ti: vitals.ti,
    datum: measuredAt ? measuredAt.toLocaleDateString('de-DE') : '',
    time: measuredAt
      ? measuredAt.toLocaleTimeString('de-DE', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
      : '',
    tool: record.tool || '',
    domain: record.domain || 'display-sales.at',
    measuredAt: measuredAt ? measuredAt.toISOString() : '',
    createdTime: record.created,
  };
}

async function request(path) {
  let response;

  try {
    response = await fetch(`${baseUrl}${path}`);
  } catch (error) {
    throw new Error(`PocketBase is not reachable at ${baseUrl}`);
  }

  if (!response.ok) {
    throw new Error(`PocketBase request failed (${response.status})`);
  }

  return response.json();
}

export const pocketBaseUrl = baseUrl;

export const speedcheckService = {
  async testConnection() {
    await request('/api/health');
    return true;
  },

  async getAllRecords() {
    const params = new URLSearchParams({
      page: '1',
      perPage: '300',
      sort: '-datum',
      filter: 'tool != "local Chrome"',
    });
    const result = await request(`/api/collections/speedchecks/records?${params.toString()}`);
    return (result.items || []).map(mapRecord);
  },

  async runSpeedcheck(domain, engine) {
    let response;

    try {
      response = await fetch(`${baseUrl}/api/speedcheck/run`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domain, engine }),
      });
    } catch (error) {
      throw new Error(`PocketBase is not reachable at ${baseUrl}`);
    }

    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(payload.message || `Speedtest failed (${response.status})`);
    }

    return payload;
  },

  latestByDomainAndTool(records) {
    const grouped = {};

    records.forEach((record) => {
      const key = `${record.domain}-${record.tool}`;
      if (!grouped[key] || new Date(record.createdTime) > new Date(grouped[key].createdTime)) {
        grouped[key] = record;
      }
    });

    return Object.values(grouped);
  },
};
